module.exports = "/_next/static/images/6bb7b1700f53c9c7684185f0369cc8c8-man-looking-at-phone@lg-1x.jpg.webp";